import { take, fork, cancel, call, put, select } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import config from '../../config/config';
import { callApi } from './callApi';
import {
  requestAgentTransactionHistory,
  successAgentTransactionHistory,
  failAgentTransactionHistory
} from '../actionCreators/grantCredit';
import { showNotification } from '../actionCreators/notification';
import { getCurrentClubAdminAccount } from '../selectors';

function* processRequestAgentTransactionHistory({ agentId }) {
  try {
    const { token } = yield select(getCurrentClubAdminAccount);
    const response = yield call(callApi, `${config.API_URL}/club/transaction`, 'GET', {
      token,
      accountId: agentId,
    });
    yield put(successAgentTransactionHistory(agentId, response.data.result.movements));
  } catch (e) {
    yield put(failAgentTransactionHistory(agentId, e));
  }
}

export function* watchAgentTransactionHistoryRequests() {
  let forked = null;
  while (true) {
    const action = yield take(actionTypes.AGENT_TRANSACTION_HISTORY_REQUEST);
    if (forked) yield cancel(forked);
    forked = yield fork(processRequestAgentTransactionHistory, action);
  }
}

function* requestAgentTransaction({ from, to, amount, agentId }) {
  try {
    const { token } = yield select(getCurrentClubAdminAccount);
    const response = yield call(callApi, `${config.API_URL}/club/transactions`, 'POST', {
      token,
      transactions: [{
        source: from,
        destination: to,
        amount: amount.toString(),
      }],
    });
    yield put(showNotification({ message: response.data.result.message }));
    yield put(requestAgentTransactionHistory(agentId));
  } catch (e) {}
}

export function* watchAgentTransactionRequests() {
  while (true) {
    const action = yield take(actionTypes.AGENT_TRANSACTION_REQUEST);
    yield fork(requestAgentTransaction, action);
  }
}